<template>
  <v-navigation-drawer
    :mini-variant="miniVariant && !$vuetify.breakpoint.mdAndDown"
    app
    :width="$vuetify.breakpoint.mdAndDown ? 250 : 150"
    mini-variant-width="48"
    class="primary"
    touchless
    v-model="showDrawer"
    v-if="mostrar"
    style="z-index:6"
  >
    <v-list class="primary" :class="{'pt-0' : !$vuetify.breakpoint.mdAndDown}">
      <v-list-tile 
        v-if="!$vuetify.breakpoint.mdAndDown"
        @click="miniVariant = !miniVariant"
      >
        <v-list-tile-action>
          <v-icon class="white--text">menu</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile
        v-for="(item, i) in items"
        :key="i"
        :to="item.to"
        :exact="item.exact"
        :title="item.title"
        active-class="primary darken-2"
        exact-active-class="primary darken-2"
      >
        <v-list-tile-action>
          <v-icon color="white" class="custom-icon">{{item.icon}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="white--text" v-text="item.title"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      miniVariant: true
    }
  },
  created () {
    this.showDrawer = !this.$vuetify.breakpoint.mdAndDown
  },
  computed: {
    ...mapGetters({
      getShowDrawer: 'showDrawer'
    }),
    mostrar () {
      return this.$route.name != null &&
        !this.$route.name.startsWith('incrustado.') &&
        !this.$route.name.startsWith('login') &&
        this.esAdministrador
    },
    showDrawer: {
      get () {
        return this.getShowDrawer
      },
      set (value) {
        this.setShowDrawer(value)
      }
    },
    items () {
      return [
        {
          icon: 'icon-home',
          title: this.$t('navDrawer.inicio'),
          to: {
            name: 'home'
          },
          exact: true
        },
        {
          icon: 'icon-reservas',
          title: this.$t('navDrawer.reservas'),
          to: {
            name: 'reservas.list'
          },
          exact: false
        },
        {
          icon: 'icon-proveedores',
          title: this.$t('navDrawer.equipo'),
          to: {
            name: 'comerciales.list'
          },
          exact: false
        },
        {
          icon: 'mdi-home-city',
          title: this.$t('navDrawer.promociones'),
          to: {
            name: 'promociones.list'
          },
          exact: false
        },
        {
          icon: 'icon-settings',
          title: this.$t('navDrawer.configuracion'),
          to: {
            name: 'configuracion'
          },
          exact: false
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      setShowDrawer: 'showDrawer'
    })
  }
}
</script>

<style lang="stylus">

  .v-list__tile__title
    transition opacity 1s

  .v-navigation-drawer--mini-variant .v-list__tile__title
    opacity 0

  .v-navigation-drawer .v-list__tile__action
    margin-left -6px
    min-width 36px

  .v-navigation-drawer.v-navigation-drawer--mini-variant .v-list__tile__action
    margin-left -12px
        
</style>


// WEBPACK FOOTER //
// src/components/NavigationDrawer.vue